// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"189":"panneau","524":"app"}[chunkId] || chunkId) + "." + {"189":"0a788300","524":"e61c9a50","565":"576811d6","694":"f67748db"}[chunkId] + ".chunk.css";
};